import { FC, useState } from 'react';
import { DownOutlined, FileSearchOutlined, TableOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import { useFelaEnhanced } from 'hooks';

import * as felaRules from './EvidencePanel.rules';
import { AssistantAnswer, AssistantMode } from '../../types';
import { ServiceLineCard } from '../ServiceLineCard';
import { SqlResultTable } from '../SqlResultTable';

interface EvidencePanelProps {
    answer: AssistantAnswer;
}

const EvidencePanel: FC<EvidencePanelProps> = ({ answer }) => {
    const isSql = answer.mode === AssistantMode.SQL;
    const [open, setOpen] = useState(true);
    const { styles } = useFelaEnhanced(felaRules, { mode: answer.mode, open });

    if (isSql && answer.sqlResult) {
        return (
            <div className={styles.container}>
                <button type="button" className={styles.toggle} onClick={() => setOpen(prev => !prev)}>
                    <span className={styles.toggleLabel}>
                        <TableOutlined />
                        <FormattedMessage
                            id="assistant.evidence.toggleTable"
                            values={{ rowCount: answer.sqlResult.rowCount }}
                        />
                    </span>
                    <DownOutlined className={styles.chevron} />
                </button>
                {open && (
                    <div className={styles.body}>
                        <SqlResultTable result={answer.sqlResult} />
                    </div>
                )}
            </div>
        );
    }

    if (!isSql && answer.sources) {
        return (
            <div className={styles.container}>
                <button type="button" className={styles.toggle} onClick={() => setOpen(prev => !prev)}>
                    <span className={styles.toggleLabel}>
                        <FileSearchOutlined />
                        <FormattedMessage
                            id="assistant.evidence.toggleSources"
                            values={{ count: answer.sources.length }}
                        />
                    </span>
                    <DownOutlined className={styles.chevron} />
                </button>
                {open && (
                    <div className={styles.body}>
                        {answer.sources.length > 0 ? (
                            <div className={styles.grid}>
                                {answer.sources.map(item => (
                                    <ServiceLineCard key={item.service_line_id} source={item} />
                                ))}
                            </div>
                        ) : (
                            <div className={styles.empty}>
                                <FormattedMessage id="assistant.evidence.noSources" />
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }

    return null;
};

export default EvidencePanel;
